export default class Storage {
  static get(key) {
    return localStorage.getItem(key);
  }

  static remove(key) {
    localStorage.removeItem(key);
  }

  static set(key, value) {
    localStorage.setItem(key, value);
  }
}
